import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Box,
  HStack,
  VStack,
  Text,
  Icon,
} from '@chakra-ui/react';
import { FiRepeat } from 'react-icons/fi';

const ArtistSwitchConfirmation = ({
  isOpen,
  onClose,
  artist,
  onConfirm,
  isLoading = false,
  cancelRef
}) => {
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
      motionPreset="slideInBottom"
    >
      <AlertDialogOverlay bg="rgba(0, 0, 0, 0.7)" backdropFilter="blur(2px)">
        <AlertDialogContent
          bg="dark.500"
          borderColor="secondary.900"
          borderWidth="1px"
          shadow="xl"
          mx={4}
          maxW="md"
        >
          <AlertDialogBody pt={6} pb={4}>
            <VStack align="start" spacing={2.5}>
              <Box
                w="full"
                p={3}
                bg="secondary.900"
                borderRadius="md"
              >
                <HStack spacing={3}>
                  <Box
                    p={2}
                    rounded="md"
                    bg="dark.900"
                  >
                    <Icon as={FiRepeat} boxSize={4} color="primary.100" />
                  </Box>
                  <VStack align="start" spacing={0} flex={1} minW={0}>
                    <Text fontSize="sm" fontWeight="bold" color="white" noOfLines={1}>
                      {artist?.artist_name}
                    </Text>
                    <Text fontSize="xs" color="primary.100" noOfLines={1}>
                      {artist?.email}
                    </Text>
                  </VStack>
                </HStack>
              </Box>
              <Text fontSize="sm" color="dark.500" lineHeight="1.4">
                You'll be able to view and manage this artist's tracks, earnings, and profile.
              </Text>
            </VStack>
          </AlertDialogBody>

          <AlertDialogFooter pt={2} pb={4}>
            <HStack spacing={3} w="full" justify="flex-end">
              <Button
                ref={cancelRef}
                onClick={onClose}
                isDisabled={isLoading}
                variant="ghost"
                color="primary.100"
                size="md"
                _hover={{ bg: "secondary.900", color: "white" }}
              >
                Cancel
              </Button>
              <Button
                onClick={onConfirm}
                isLoading={isLoading}
                loadingText="Switching..."
                variant="brand"
                size="md"
                _hover={{
                  transform: "translateY(-1px)",
                  boxShadow: "lg"
                }}
                transition="all 0.2s"
              >
                Switch
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ArtistSwitchConfirmation;
